@if (isShowing) {
  <section id="fullscreen-gallery" @enterLeaveFadeAnimation cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <header>
      @if (currentImage?.IsFavoritable) {
        <favorite-btn [isActive]="currentImage?.IsFavorited" (toggle)="handleFavoriteToggle($event)">
        </favorite-btn>
      }
      @if (currentImage?.Title) {
        <h3 [matTooltip]="currentImage?.Title">{{currentImage?.Title}}</h3>
      }
      @if (images.length > 1 && !hideGalleryControls) {
        <div class="pager">
          @if (images.length > 1) {
            <icon-button ariaLabel="Previous" [class.btn-background]="buttonBkgEnabled" icon="carrot_arrow" class="left-arrow"
            (click)="goToImage(selectedIndex - 1)"></icon-button>
          }
          <p>
            <b>{{selectedIndex + 1}}</b> of {{images.length}}
          </p>
          @if (images.length > 1) {
            <icon-button ariaLabel="Next" [class.btn-background]="buttonBkgEnabled" icon="carrot_arrow" class="right-arrow"
            (click)="goToImage(selectedIndex + 1)"></icon-button>
          }
        </div>
      }
      <button aria-label="Close Fullscreen" class="close-btn" (click)="closeFullscreen()">
        <icon name="x"></icon>
      </button>
    </header>
    @if (isLoading && images.length && !currentImage?.IsVideo) {
      <div class="loader" @enterLeaveFadeAnimation>
        <div class="spin-stretch"></div>
      </div>
    }
    <div class="swipe-container">
      <div class="swipe-wrapper" gallerySwiper [index]="selectedIndex" [slideCount]="images.length" (indexChange)="handleSwipeIndexChange($event)">
        @for (item of images; track trackById(i, item); let i = $index) {
          <div class="image-slide">
            @if (selectedIndex - 1 <= i && i <= selectedIndex + 1) {
              @if (!item.IsVideo && !item.IsIframe && !item.InnerHtml) {
                <img [class.fullscreen]="fullscreen && item.Type !== types.Floor"
                  [src]="item.FullUrl" (load)="onImgLoad()" @enterLeaveFadeAnimation>
              }
              @if (item.InnerHtml) {
                <div class="svg-container" [innerHTML]="item.InnerHtml | safeHtml"></div>
              }
              @if (item?.IsIframe) {
                <iframe [src]="item.FullUrl | safeUrl" (load)="onImgLoad()"></iframe>
              }
              @if (item?.IsVideo) {
                <video-with-preview [src]="item.FullUrl" [previewUrl]="item.ThumbnailUrl" [showControls]="true"
                [startTime]="item.VideoTime" @enterLeaveFadeAnimation></video-with-preview>
              }
            }
          </div>
        }
      </div>
    </div>
  </section>
}